function getTranslatedEEIndividual(ee_individual){
    if(ee_individual === 'NO') return "Nein";
    else if(ee_individual === 'YES') return "Ja";
}

export default getTranslatedEEIndividual;